import styles from "gui/feature/feature.module.css";
import { ButtonOld } from "components/ButtonOld/ButtonOld";
import { Cell } from "gui/grid/cell";
import { Grid } from "gui/grid/grid";
import { Icon } from "gui/icon/icon";
import { Quote } from "gui/quote/quote";
import { SanityFeature } from "lib/sanity/types";
import { Subtitle } from "gui/subtitle/subtitle";
import { TextBlocks } from "gui/text/text";

export const Feature: React.FC<{
  item: SanityFeature;
}> = (props) => {
  const id = `aria-${props.item._key}`;

  return (
    <Grid aria-labelledby={id} className={styles.grid} revealOnScroll gaps>
      <Subtitle id={id} text={props.item.title} icon={props.item.icon} />
      <Cell span6="lg" className={styles.info}>
        <TextBlocks className={styles.title} blocks={props.item.subtitle} />
        <TextBlocks className={styles.text} blocks={props.item.text} />
        {props.item.action && props.item.link && (
          <ButtonOld href={props.item.link} className={styles.button} color2>
            {props.item.action}
            <Icon icon="arrow-right" />
          </ButtonOld>
        )}
      </Cell>
      {props.item.code && (
        <Cell span6="lg">
          <div className={styles.code}>
            <pre aria-label="Sample code">
              <span>SELECT</span> SUM(token_a_amount) AS dai_bought
              <br />
              <span>FROM</span> dex.trades
              <br />
              <span>WHERE</span> block_time {">"} now() - interval '24 hours'
              <br />
              <span>AND</span> token_a_symbol = 'DAI';
            </pre>
          </div>
        </Cell>
      )}
      {!props.item.code && props.item.quote && (
        <Cell span6="lg">
          <Quote item={props.item.quote} />
        </Cell>
      )}
    </Grid>
  );
};
